/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Project_Tag_Create_InlineInputs */



/**
* | output |
* | --- |
* | "Create \"{name}\"" |
*
* @param {Project_Tag_Create_InlineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tag_create_inline = /** @type {((inputs: Project_Tag_Create_InlineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tag_Create_InlineInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.name}" erstellen`)
	return /** @type {LocalizedString} */ (`Create "${i?.name}"`)
});